import React, { FC } from "react";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { withRouter, useRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Head from "next/head";

import Footer from "../../src/components/Footer/Footer";
import { useColorModeContext } from "../../src/contexts/CustomThemeProvider";
import AudienceShows from "../../src/pages/Audience/AudienceShows";

interface ShowDetailsPageProps extends WithRouterProps {
}

const ShowDetailsPage: FC<ShowDetailsPageProps> = () => {
    const router = useRouter()
    const promoCode = router.query.promoCode as string;

    const { setColorMode } = useColorModeContext();
    setColorMode("dark");

    return (
        <>
            <Head>
                <title>{`Shows | That's The Ticket`}</title>
                <meta key="ogTitle" property="og:title" content="Shows" />
                <meta key="twitterTitle" name="twitter:title" content="Shows" />
            </Head>
            <AudienceShows />
            <Footer />
        </>
    );
}

export default withRouter(ShowDetailsPage);

export const getServerSideProps: GetServerSideProps = async ({ params }: GetServerSidePropsContext) => {

    return {
        props: {
        }
    }
}